import * as AvatarPrimitive from "@radix-ui/react-avatar";

import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

export default function Avatar({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        "bg-border-primary relative flex size-8 shrink-0 overflow-hidden rounded-full",
        className,
      )}
      {...props}
    />
  );
}

export function AvatarImage({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn("aspect-square size-full", className)}
      {...props}
    />
  );
}

export function AvatarFallback({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        "text-background flex size-full items-center justify-center rounded-full",
        className,
      )}
      {...props}
    />
  );
}

export function createAvatarFallback(name?: string) {
  if (!name) {
    return "?";
  }
  const parts = name.split(" ");
  return parts
    .filter((part) => part && part.length > 0)
    .map((part) => part[0].toUpperCase())
    .join("");
}
